export const CHECKBOX_BASE_CLASSES =
  "h-4 w-4 cursor-pointer rounded border border-[#E5E5E5] " +
  "bg-white appearance-none " +
  "checked:bg-[#3551F3] checked:border-[#3551F3] " +
  "focus:outline-none focus:ring-2 focus:ring-[#3551F3] " +
  "checked:before:content-['✓'] checked:before:text-white " +
  "checked:before:flex checked:before:items-center checked:before:justify-center " +
  "checked:before:h-full checked:before:w-full checked:before:text-xs";

export const ACTIVE_CELL_BG = "#F3F4F6";
export const ACTIVE_CELL_BORDER = "#4B5563";
